// extracted by mini-css-extract-plugin
var _1 = "ReflectionElement_demo__c3670";
var _2 = "ReflectionElement_root__1d1bf";
var _3 = "ReflectionElement_textarea__1f2b3";
export { _1 as "demo", _2 as "root", _3 as "textarea" }
